<template>
  <div :class="['card', color && `${color}-color`]">
    <div class="row no-gutters align-items-center">
      <div :class="['col', flip && 'order-1']">
        <img
          :src="require(`@/assets/funFacts/${image}`)"
          class="card-img img-fluid"
        >
      </div>
      <div class="col width">
        <div class="card-body">
          <h4
            v-if="header"
            v-t="{ path: header, args: number(value) }"
            :class="['text-uppercase text-condensed', color === 'info' ? 'text-warning' : 'text-secondary']"
          />
          <p
            :class="[
              'm-0 small text-uppercase font-weight-bold lh-13 text-condensed',
              color === 'info' ? 'text-white' : 'text-primary'
            ]"
          >{{ $tc(text, value[0] || value, number(Array.isArray(value) ? value : [value])) }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import number from '@/filters/number'

export default {
  name: 'FunFactsCard',
  props: {
    header: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    image: {
      type: String,
      required: true
    },
    value: {
      type: [Number, String, Array],
      required: true
    },
    flip: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: undefined
    }
  },
  methods: {
    number(value) {
      if (Array.isArray(value)) {
        return value.map(item => this.number(item))
      }

      if (Number(value)) {
        return number(value, this.$i18n.locale)
      }

      return value
    }
  }
}
</script>

<style lang="scss">
.width {
  flex: 0 0 percentage(divide(193, 343)) !important;
}
.info-color{
  background-color: #575F92;
}
.illustration-medium-color{
  background-color: #B3B7CC;
}
.light-color{
  background-color: #EBEDF2;
}

</style>
